import React from "react"
import Col from "react-bootstrap/Col"
import Flash from "react-reveal/Flash"

const BlogHeading = () => {
  return (
    <section className="row mx-0 wfBackground d-none d-sm-block">
      <Col style={{ paddingTop: "80px" }}>
        <Flash delay={1000}>
          <h1 className="pt-1 text-center display-4">Welcome To My Blog</h1>
        </Flash>
      </Col>
    </section>
  )
}

export default BlogHeading
